import { render, staticRenderFns } from "./DemoGuideArticle.vue?vue&type=template&id=65fb5c33&"
import script from "./DemoGuideArticle.vue?vue&type=script&lang=js&"
export * from "./DemoGuideArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports